import { makeStyles } from "tss-react/mui";

import { Breadcrumbs, Link, Theme, Typography } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => {
    const { fontFamily, fontSize, fontWeight, letterSpacing, lineHeight } = theme.typography.body2;

    return {
        breadcrumbs: {
            fontFamily,
            fontSize,
            fontWeight,
            letterSpacing,
            lineHeight,
            "& .MuiBreadcrumbs-li": {
                display: "inline-flex",
                alignItems: "center",
            },
        },
        crumb: {
            display: "inline-flex",
            alignItems: "center",
            margin: 0,
            padding: 0,
        },
        text: {
            color: theme.palette.emteria.text.primary,
        },
        link: {
            cursor: "pointer",
            border: "none",
            background: "none",
            textAlign: "left",
            textDecoration: "none",
            color: theme.palette.emteria.link,
            padding: 0,
            minWidth: 0,
            "&:hover": {
                color: theme.palette.emteria.warning,
            },
        },
    };
});

type Props = {
    groups: API.Group[];
    workspaceLabel: string;
    onSelect?: (groupId: number | null) => void;
};

export const GroupBreadcrumbs = ({ groups, onSelect, workspaceLabel }: Props) => {
    const { classes, cx } = useStyles();

    if (!onSelect) {
        if (groups.length === 0) {
            return (
                <Breadcrumbs className={classes.breadcrumbs}>
                    <Typography variant="body2" component="span" className={cx(classes.crumb, classes.text)}>
                        {workspaceLabel}
                    </Typography>
                </Breadcrumbs>
            );
        }

        return (
            <Breadcrumbs className={classes.breadcrumbs}>
                <Typography variant="body2" component="span" className={cx(classes.crumb, classes.text)}>
                    {workspaceLabel}
                </Typography>
                {groups.map((group) => (
                    <Typography key={group.id} variant="body2" component="span" className={cx(classes.crumb, classes.text)}>
                        {group.name}
                    </Typography>
                ))}
            </Breadcrumbs>
        );
    }

    if (groups.length === 0) {
        return (
            <Breadcrumbs className={classes.breadcrumbs}>
                <Typography variant="body2" component="span" className={cx(classes.crumb, classes.text)}>
                    {workspaceLabel}
                </Typography>
            </Breadcrumbs>
        );
    }

    return (
        <Breadcrumbs className={classes.breadcrumbs}>
            <Link
                variant="body2"
                component="button"
                type="button"
                underline="none"
                onClick={() => onSelect(null)}
                className={cx(classes.crumb, classes.link)}
            >
                {workspaceLabel}
            </Link>
            {groups.map((group, index) => {
                const isLast = index === groups.length - 1;
                if (isLast) {
                    return (
                        <Typography key={group.id} variant="body2" component="span" className={cx(classes.crumb, classes.text)}>
                            {group.name}
                        </Typography>
                    );
                }
                return (
                    <Link
                        key={group.id}
                        variant="body2"
                        component="button"
                        type="button"
                        underline="none"
                        onClick={() => onSelect(group.id)}
                        className={cx(classes.crumb, classes.link)}
                    >
                        {group.name}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};
